import { render } from "./Talents.vue?vue&type=template&id=54e0c0d1"
import script from "./Talents.vue?vue&type=script&lang=js"
export * from "./Talents.vue?vue&type=script&lang=js"

import "./Talents.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__